// material-ui
import { Box } from "@mui/material";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

// ==============================|| CUSTOM LOADING SPINNER ||============================== //

const LoadingSpinner = () => {

    return (
        <Box style={{ margin: '200px 0', width: '100%', textAlign: 'center' }}>
            <CircularProgress color="inherit" />
        </Box>
    );
};

export default LoadingSpinner;